import React from "react";
import {Dashboard} from "./Dashboard/index";


export function DashboardPage() {
  return <Dashboard />;
}
